export default __webpack_public_path__ + "static/media/header-logo.7f88b6b0.svg";